import React, { createContext } from "react";
import { UserSessionDto } from "../models/User";
import { AlertColor } from "@mui/material";

export interface IAppContext {
	title: string;
	setTitle: (title: string) => void;
	setUserContext: (userContext: UserSessionDto | null) => void;
	userContext: UserSessionDto | null;
	snackBar: {
		open: boolean;
		message: string;
		autoHideDuration: number;
		severity: AlertColor;
		onClose: (event: React.SyntheticEvent | Event) => void;
	};
	setSnackBar: (snackBar: {
		open: boolean;
		message: string;
		autoHideDuration: number;
		severity: AlertColor;
		onClose: (event: React.SyntheticEvent | Event) => void;
	}) => void;
}

export const AppContext = createContext<IAppContext>({
	title: "",
	setTitle: (title: string) => {},
	setUserContext: (userLoggedIn: UserSessionDto | null) => {},
	userContext: null,
	snackBar: {
		open: false,
		message: "",
		autoHideDuration: 6000,
		severity: "success",
		onClose: (event: React.SyntheticEvent | Event) => {},
	},
	setSnackBar: (snackBar: {
		open: boolean;
		message: string;
		autoHideDuration: number;
		severity: AlertColor;
		onClose: (event: React.SyntheticEvent | Event) => void;
	}) => {},
});
